import React from 'react';
import PropTypes from 'prop-types';
import './OnboardingMultiContent.css';
import { OnboardingCard } from '../OnboardingCard';

export const OnboardingMultiContent = ({
  onboardingStepInfo,
  handleCardSelected,
  handleGoToSection,
  references,
  handleAddReference,
  handleReferenceInputChange,
  handleAddContactInfo,
  handleNextStep,
  handleSaveManagementWay,
  handleCardInputChange,
}) => {
  const { cards, current_section: currentSection } = onboardingStepInfo;

  return (
    <div>
      {cards.map((cardMulti, index1) => (
        <div
          className={`onboarding__multi-content onboarding__multi-content--${
            index1 === currentSection ? 'visible' : 'hidden'
          }`}
          key={String(index1)}
        >
          <div className="onboarding-step__hero">{cardMulti.hero}</div>
          <div className="onboarding-step__description">
            {cardMulti.description}
          </div>
          <div className="onboarding-step__content">
            {cardMulti.inner_cards.map((cardInfo, index) => (
              <OnboardingCard
                cardInfo={{ ...cardInfo, inputValue: cardMulti.inputValue }}
                key={String(index)}
                selectedValue={onboardingStepInfo.selectedValue}
                handleCardSelected={handleCardSelected}
                references={references}
                handleAddReference={handleAddReference}
                handleReferenceInputChange={handleReferenceInputChange}
                handleGoToSection={handleGoToSection}
                handleAddContactInfo={handleAddContactInfo}
                handleNextStep={handleNextStep}
                handleSaveManagementWay={handleSaveManagementWay}
                handleCardInputChange={handleCardInputChange}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

OnboardingMultiContent.propTypes = {
  onboardingStepInfo: PropTypes.object,
  handleCardSelected: PropTypes.func,
  handleGoToSection: PropTypes.func,
  references: PropTypes.array,
  handleAddReference: PropTypes.func,
  handleReferenceInputChange: PropTypes.func,
  handleAddContactInfo: PropTypes.func,
  handleNextStep: PropTypes.func,
  handleSaveManagementWay: PropTypes.func,
  handleCardInputChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/OnboardingMultiContent/OnboardingMultiContent.js